import { ListFilters } from "apps/customLists/components/filterScreens";
import { TagByIdsQuery, TagGroupByIdsQuery } from "gql/generated";
import { TFunction } from "i18next";
import {
  FilterOptionItem,
  getTagsNamesForTagRelatedFilters,
} from "shared/components";

export const getFilterTagData = (
  t: TFunction<"translation", undefined>,
  filterOptionItem: FilterOptionItem,
  appliedFilters: ListFilters,
  tags: TagByIdsQuery["tagByIds"],
  tagGroups: TagGroupByIdsQuery["tagGroupByIds"],
) => {
  switch (filterOptionItem.key) {
    case "OPERATOR_TYPE": {
      const tagNames = getTagsNamesForTagRelatedFilters({
        tags,
        tagGroups,
        appliedFilters,
        tagKey: "businessType",
      });

      return tagNames;
    }
    case "KEYWORD_TAGS": {
      const tagNames = getTagsNamesForTagRelatedFilters({
        tags,
        tagGroups,
        appliedFilters,
        tagKey: "global",
      });

      return tagNames;
    }
    case "BACK_OFFICE_TAGS": {
      const tagNames = getTagsNamesForTagRelatedFilters({
        tags,
        tagGroups,
        appliedFilters,
        tagKey: "organizationSpecific",
      });
      return tagNames;
    } 
    case "AMENITY_TAGS": {
      const tagNames = getTagsNamesForTagRelatedFilters({
        tags,
        tagGroups,
        appliedFilters,
        tagKey: "amenity",
      });
      return tagNames;
    }
    case "PRICING": {
      return appliedFilters.pricing.map((pricing) =>
        t(`core:LOOKUPS.OPERATOR_PRICING.${pricing}`),
      );
    }
    case "MEDIA_QUALITY": {
      return appliedFilters.mediaQuality.map((quality) =>
        t(`core:LOOKUPS.OPERATOR_AVG_IMAGE_QUALITY.${quality}`),
      );
    }
    case "OPENING_STATUS": {
      return appliedFilters.operationalStatus.map((status) =>
        t(`core:LOOKUPS.OPERATOR_OPERATIONAL_STATUS.${status}`),
      );
    }
    case "DAYS_OF_OP": {
      return appliedFilters.daysOfOperation.map((day) =>
        t(`core:LOOKUPS.DAYS.${day}_FULL`),
      );
    }
    case "SEASONALITY": {
      return appliedFilters.seasonality.map((month) =>
        t(`core:LOOKUPS.MONTHS.${month}_FULL`),
      );
    }
    case "OPERATOR_VISIBILITY": {
      return appliedFilters.visibility.length > 0
        ? [t(`core:LOOKUPS.PUBLICATION_STATUS.${appliedFilters.visibility}`)]
        : [];
    }
    case "DIGITAL_HEALTH": {
      return appliedFilters.digitalHealth.map((op) =>
        t(`core:LOOKUPS.DIGITAL_HEALTH.${op}`),
      );
    }
    case "LOCATION": {
      return appliedFilters.location.address
        ? [appliedFilters.location.address]
        : [];
    }
    default:
      return [];
  }
};
